export default __webpack_public_path__ + "static/media/sixPieces4.4585d1fe.jpg";